import React from 'react';
import './CurrentLocationMarker.scss';

type CurrentLocationMarkerProps = {
  lat: number;
  lng: number;
  onClick?: () => void;
};

/**
 * CurrentLocationMarker - Displays user's current location on the map
 *
 * Shows a distinctive blue dot with pulse animation to indicate current position.
 * Follows Material Design location marker conventions.
 */
function CurrentLocationMarker({ onClick }: CurrentLocationMarkerProps) {
  return (
    <div
      className='current-location-container'
      onClick={onClick}
    >
      <div className='current-location-pulse' />
      <div className='current-location-dot' />
    </div>
  );
}

CurrentLocationMarker.displayName = 'CurrentLocationMarker';
export default CurrentLocationMarker;
